.method-image-wrapper {
  position: relative;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 0 0.5rem;

  width: 10rem;
  height: 10rem;
  border: 1px solid #d9d9d9;
  border-radius: 5px;

  .selected > & {
    //background-color: rgba(68, 204, 0, 0.1);
    border: 2px solid rgb(68 204 0 / 0.5);
  }

  & > img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 5px;

    &.local {
      width: 80%;
      border-radius: 0;
    }
  }
}
